import React from 'react'

const Allfood = () => {
  return (
    <div>Allfood</div>
  )
}

export default Allfood